import { get } from 'lodash'
import type { IEntityDataItem, IEntitySelectItem } from '~/types/models'

export function getEntitySelectItemFromEntityDataItem({
  item,
  itemIdPathString,
  itemLabelPathString,
}: {
  item: IEntityDataItem | undefined
  itemIdPathString?: string
  itemLabelPathString?: string
}): IEntitySelectItem | undefined {
  function _getForItem(pathString: string) {
    return get(item, pathString)
  }
  if (!item) {
    return undefined
  }
  if (itemLabelPathString && itemIdPathString) {
    const id = _getForItem(itemIdPathString)
    const label = _getForItem(itemLabelPathString)
    return { id, label }
  }
  if (itemLabelPathString) {
    const label = _getForItem(itemLabelPathString)
    return { id: item.id, label }
  }
  if (itemIdPathString) {
    const id = _getForItem(itemIdPathString)
    return { id, label: item.label }
  }
  return { id: item.id, label: item.label }
}
